import * as React from "react";
import { Checkbox as ShadcnCheckbox } from "../checkbox";
import { cn } from "@/lib/utils";

export interface CheckboxProps extends Omit<
  React.ComponentPropsWithoutRef<typeof ShadcnCheckbox>,
  "checked"
> {
  isSelected?: boolean;
  isDisabled?: boolean;
  onValueChange?: (checked: boolean) => void;
  size?: "sm" | "md" | "lg";
  radius?: "none" | "sm" | "md" | "lg" | "xl" | "full";
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  classNames?: {
    base?: string;
  };
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof ShadcnCheckbox>,
  CheckboxProps
>(
  (
    {
      isSelected,
      isDisabled,
      disabled,
      size,
      radius,
      color,
      onValueChange,
      onCheckedChange,
      classNames,
      className,
      ...props
    },
    ref
  ) => {
    const radiusClasses = {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      full: "rounded-full",
    };

    const handleCheckedChange = React.useCallback(
      (checked: boolean) => {
        onValueChange?.(checked);
        onCheckedChange?.(checked);
      },
      [onValueChange, onCheckedChange]
    );

    return (
      <ShadcnCheckbox
        ref={ref}
        checked={isSelected}
        disabled={disabled ?? isDisabled}
        onCheckedChange={handleCheckedChange}
        className={cn(
          radius && radiusClasses[radius],
          classNames?.base,
          className
        )}
        {...props}
      />
    );
  }
);
Checkbox.displayName = "Checkbox";

export { Checkbox };
